export default {
  mounted(el: HTMLImageElement, binding: { value: string }) {
    if (!binding.value) {
      console.warn('Lazy directive requires a value for the src attribute')
      return
    }
    const observer = new IntersectionObserver(([entry], observer) => {
      if (entry.isIntersecting) {
        el.src = binding.value
        observer.unobserve(el)
      }
    })
    observer.observe(el)
    // Store observer reference for cleanup
    ;(el as any)._lazy_observer = observer
  },
  unmounted(el: HTMLImageElement & { _lazy_observer?: IntersectionObserver }) {
    // Clean up observer when element is unmounted
    if (el._lazy_observer) {
      el._lazy_observer.unobserve(el)
      delete el._lazy_observer
    }
  },
}
